import ApiClient from '@/services/apiClient';
import moment from 'moment';

export default class Alert {
    id;
    description;
    component;
    timestamp;
  
    static constructFromObject(data, obj) {
      obj = obj || new Alert();
      if(data) {
        obj.id = ApiClient.convertToType(data['id'], 'Integer');
        obj.description = ApiClient.convertToType(data['description'], 'String');
        obj.component = ApiClient.convertToType(data['component'], 'String');
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Date');
      }
      return obj;
    }

    get getAlertDate() {
      return moment(this.timestamp).format('DD/MM/YYYY HH:mm:ss');
    }
}